import { Box, Typography } from '@mui/material';
import { JSX } from 'react';

export const SidebarItem = ({
  isSelected,
  Icon,
  onClick,
  name,
  EndIcon,
}: {
  isSelected?: boolean;
  Icon: JSX.Element;
  onClick: any;
  name: string;
  EndIcon?: React.ReactNode;
}) => {
  return (
    <Box
      onClick={onClick}
      role="link"
      aria-current={isSelected}
      tabIndex={0}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          borderRadius: 2,
          py: 1,
          px: { xs: 1, md: 2 },
          cursor: 'pointer',
          my: 1,
          ml: 2,
          mr: 2,
          ...(isSelected
            ? {
                bgcolor: 'sidebar.selected',
              }
            : {
                '&:hover': {
                  bgcolor: 'sidebar.hover',
                },
              }),
        },
      ]}>
      <Box
        sx={[
          {
            mr: 1,
            display: 'flex',
            alignItems: 'center',
            color: isSelected ? 'sidebar.selectedText' : 'primary.main',
          },
        ]}>
        {Icon}
      </Box>
      <Box>
        <Typography
          variant="body2"
          sx={[
            { color: isSelected ? 'sidebar.selectedText' : 'primary.main' },
          ]}>
          {name}
        </Typography>
      </Box>
      {EndIcon && <Box sx={{ ml: 'auto', mr: 1 }}>{EndIcon}</Box>}
    </Box>
  );
};
